import { MEMBERSHIP_PLANS } from 'features/membership/membership.constants';
import {
  SupportPlan,
  SupportQueryParams,
  MEMBERSHIP_URL_PARAM_KEYS,
  MembershipQueryParams,
} from '../../membership.types';

const VALID_SUPPORT_PLANS = new Set<SupportPlan>([
  MEMBERSHIP_PLANS.yearly,
  MEMBERSHIP_PLANS.proYearly,
  MEMBERSHIP_PLANS.proMonthly,
  'donate',
  'teams',
]);

const isSupportPlan = (plan: string | undefined): plan is SupportPlan =>
  Boolean(plan && VALID_SUPPORT_PLANS.has(plan as SupportPlan));

export const parseSupportQueryParams = (
  params: MembershipQueryParams,
): SupportQueryParams => {
  const plan = (params[MEMBERSHIP_URL_PARAM_KEYS.plan] ?? null) || undefined;
  const source =
    (params[MEMBERSHIP_URL_PARAM_KEYS.source] ?? null) || undefined;

  return {
    plan: isSupportPlan(plan) ? plan : undefined,
    source,
  };
};
